module.exports = __webpack_public_path__ + "img/lnk-sales.98dec5d6.svg";